import React, { useState } from "react";
import { useEffect } from "react";
import "./Accessories.css";
import hpDesktop from '../../assets/Accessories/laptopImg.png';
import IndustrialPc from '../../assets/Accessories/IndustrialPc.png';
import advantech from '../../assets/Accessories/AdvantachPc.png';
import graphicCard from '../../assets/Accessories/graphicCard.png';
import MsOffice from '../../assets/Accessories/MsOffice.png';
import tallyERp from '../../assets/Accessories/tally-logo-black.svg';
import windows11 from '../../assets/Accessories/window11image.jpg';
import hpInkTankPrinter from '../../assets/Accessories/hpSmartInkprinter.jpg';
import canonCartridge from '../../assets/Accessories/cannonCartilage.jpg';
import esponInkImage from '../../assets/Accessories/esponink.jpg';
import colourToner from '../../assets/Accessories/colourtoner.webp';
import linuxServer from '../../assets/Accessories/linuxServer.jpg';
import windowsServer from '../../assets/Accessories/windowsServer.jpg';
import Hikvision from '../../assets/Accessories/hikVissionCamera.png';
import AssembledPcImage from '../../assets/Accessories/assembledPcImage.png';
import latestBulletCamrea from '../../assets/Accessories/latestbulletcamera.jpg';
import latestDvr from '../../assets/Accessories/latestDvr.webp';
import ourWork from '../../assets/Accessories/cctvWork.png';
import dlinkRouter from '../../assets/Accessories/dlinnkRouter.jpg'
import lanCable from '../../assets/Accessories/lanCable.jpg';
import wireLessMouse from '../../assets/Accessories/wirelessMouse.png';
import keyboards from '../../assets/Accessories/keyboards.webp';
import extentionBoard from '../../assets/Accessories/DlinkExtentionBoard.png';
import ssdImage from '../../assets/Accessories/ssdEvm.png';
import Antivirusquick from '../../assets/Accessories/quickHeal.jpg';
import AntivirusNpAv from '../../assets/Accessories/npAvprotector.jpg';
import Antivirus2 from '../../assets/Accessories/antivirus2.png';

const categories = {
  "Computer Hardware": [
    { title: "All Laptops", img: hpDesktop },
    { title: "Industrial PC", img: IndustrialPc },
    { title: "Advantech PC", img: advantech },
    { title: "NVIDIA GEFORCE RTX3050 GRAPHIC CARD", img: graphicCard },
    {title: "Assembled Gaming Pc", img: AssembledPcImage}
  ],
  Software: [
    { title: "Windows 11", img: windows11 },
    { title: "MS Office", img: MsOffice },
    { title: "Tally ERP", img: tallyERp },
  ],
  "Printer/Toner": [
    { title: "HP Smart Tank 580", img: hpInkTankPrinter },
    { title: "Canon Cartridge", img: canonCartridge },
    { title: "Epson 003 65ml Ink Bottles", img: esponInkImage },
    { title: "Ink HP CF510 / CF 204A COLOR TONER CARTRIDGE", img: colourToner },
  ],
  "Web Server": [
    { title: "Linux Server", img: linuxServer },
    { title: "Windows Server", img: windowsServer },
  ],
  "CCTV Camera": [
    { title: "Hikvision Cameras", img: Hikvision },
    { title: "CP Plus 2.4MP Bullet Camera", img: latestBulletCamrea },
    { title: "CP Plus 8 Channel DVR", img: latestDvr },
    { title: 'CCTV Work, Moshi',  img: ourWork}
  ],
  "Network Products": [
    { title: "D-Link DIR-650IN Wireless N300 Router", img: dlinkRouter },
    { title: "LAN Cable", img: lanCable },
  ],
  "Small Products": [
    { title: "Mouse", img: wireLessMouse },
    { title: "Keyboard", img: keyboards },
    { title: "Extention Board", img: extentionBoard },
    { title: 'SSD', img: ssdImage}
  ],
  Antivirus: [
    { title: "Quick Heal", img: Antivirusquick },
    { title: "Net Protector Antivirus", img: AntivirusNpAv},
    { title: "Total Security Antivirus", img: Antivirus2 },
  ],
};

const Accessories = () => {
  const [activeTab, setActiveTab] = useState("Computer Hardware");
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },);
  return (
    <section className="accessories-section container">
      <h1 className="page-title">Products Gallery</h1>

      {/* TABS */}
      <ul className="nav nav-tabs custom-tabs">
        {Object.keys(categories).map((category) => (
          <li className="nav-item" key={category}>
            <button
              className={`nav-link ${
                activeTab === category ? "active" : ""
              }`}
              onClick={() => setActiveTab(category)}
            >
              {category}
            </button>
          </li>
        ))}
      </ul>

      {/* TAB CONTENT */}
      <div className="tab-content fade-animation">
        <div className="products-grid">
          {categories[activeTab].map((item, index) => (
            <div className="product-card" key={index}>
              <img src={item.img} alt={item.title} />
              <p className="product-title">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accessories;
